import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const SubscriptionPlan = ({ plan, isSelected, onClick, displayName, price, billingCycle }) => {
  return (
    <div
      className={cn('plan', { 'plan--selected': isSelected })}
      role="button"
      tabIndex="0"
      onClick={onClick}
    >
      <h2>{displayName}</h2>
      <div className="plan__billing">
        ${price}/{billingCycle}
      </div>
    </div>
  );
};

SubscriptionPlan.propTypes = {
  plan: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  billingCycle: PropTypes.string.isRequired,
};

export default SubscriptionPlan;
